import React from 'react';
import PropTypes from 'prop-types';
import findIndex from 'lodash/findIndex';

import styles from './styles.css';

const toggleQuality = (qualityLevels, item) => {
  for (var i = 0; i < qualityLevels.length; i++) {
    qualityLevels[i].enabled =
      item.id === 'auto' || qualityLevels[i].id === item.id;
  }
};

class QualityButton extends React.Component {
  constructor(props) {
    super(props);
    this.player = props.xingPlayer.videojs;
    this.state = { qualityLevels: this.getQualityLevels() };
    this.listenToAddQuality();
  }

  componentWillUnmount = () => {
    this.player.qualityLevels().off('addqualitylevel');
  };

  getQualityLevels = () =>
    this.player.qualityLevels().levels_.sort((a, b) => a.height - b.height);

  listenToAddQuality = () => {
    this.player.qualityLevels().on('addqualitylevel', () => {
      this.setState({ qualityLevels: this.getQualityLevels() });
    });
  };

  updateMenu = () => {
    const qualityLevels = this.state.qualityLevels;
    const isAuto = findIndex(qualityLevels, (item) => !item.enabled) < 0;
    let menuList = [];

    for (let i = 0; i < qualityLevels.length; i++) {
      if (qualityLevels[i].height) {
        menuList.push({
          id: qualityLevels[i].id,
          label: qualityLevels[i].height + 'p',
          selected: !isAuto && qualityLevels[i].enabled,
        });
      }
    }
    menuList.push({ id: 'auto', label: 'auto', selected: isAuto });

    const select = (item) => {
      toggleQuality(qualityLevels, item);
    };

    this.props.xingPlayer.setMenu('quality', menuList, select);
  };

  render() {
    if (this.state.qualityLevels.length === 0) {
      return null;
    }
    return (
      <div className={styles.qualityButtonContainer}>
        <button
          className={
            styles.qualityButton + ' vjs-quality-control vjs-control vjs-button'
          }
          type="button"
          onClick={() => this.updateMenu()}
        >
          <span aria-hidden="true" className="vjs-icon-placeholder" />
        </button>
      </div>
    );
  }
}

QualityButton.propTypes = {
  xingPlayer: PropTypes.object.isRequired,
};

export default QualityButton;
